export function getMockMarketData(_symbol: string) {
  return [];
}

export class MockMarketDataService {
  private static instance: MockMarketDataService;
  static getInstance() {
    if (!MockMarketDataService.instance) {
      MockMarketDataService.instance = new MockMarketDataService();
    }
    return MockMarketDataService.instance;
  }
  connect() {}
  disconnect() {}
  subscribeToOrderbook(_symbol: string, _callback: (data: any) => void) { return () => {}; }
  subscribeToOrderBook(_symbol: string, _callback: (data: any) => void) { return () => {}; }
  subscribeToTrades(_symbol: string, _callback: (data: any) => void) { return () => {}; }
  getOrderBook(_symbol: string) {
    return { bids: [], asks: [] };
  }
  getRecentTrades(_symbol: string) {
    return [];
  }
}
